import { DEFAULT_REPORTED_CHANNELS } from './constants';

class EventsReporter {
    /**
     * Reports an event to all reporting channels (grafana, bigQuery, mixpanel).
     * In case no specific channel is supplied, the event is reported to all channels.
     *
     * @param {string} eventKey - The reported event key
     * @param {Object} [eventParams] - The reported event params
     * @param {Object[]} [reportingChannels] - The desired reporting channels for the event to report to
     */
    report(eventKey, eventParams = {}, reportingChannels = DEFAULT_REPORTED_CHANNELS) {
        if (!eventKey) {
            return;
        }

        reportingChannels.forEach(({ events, reporter }) => this._reportEvent(events[eventKey], reporter, eventParams));
    }

    /**
     * Reports an event to a specific reporting channel using a supplied reporter.
     *
     * @param {Function} eventBuilder - The method to be used for building the reported event.
     * @param {Function} reporter - The reporter method.
     * @param {Object} eventParams
     */
    _reportEvent(eventBuilder, reporter, eventParams) {
        if (!eventBuilder) {
            return;
        }

        const event = eventBuilder(eventParams);

        reporter(event);
    }
}

export default new EventsReporter();
